<!-- zym.连续型电子出版物 - 核验进度 -->
<template>
  <div class="press-5">
    <div class="tabTtl">
      <span>连续型电子出版物核验进度</span>

      <!-- <a @click="toCancel" class="downBtn" style="margin-right: 10px; margin-left: 10px">
        <el-button type="danger" size="small">整体撤回</el-button>
      </a> -->

      <a :href="fileUrl" class="downBtn" download>
        <el-button size="small">下载封面和盖章页</el-button>
      </a>
    </div>
    <div class="tabArea">
      <el-table :data="tabDat" border style="width: 100%" v-loading="loading">
        <el-table-column label="序号" width="60" align="center" type="index">
          <template slot-scope="scope">
            {{ scope.$index + 1 + 15 * (tabPost.no - 1) }}
          </template>
        </el-table-column>
        <el-table-column label="核验年度" align="center">
          <template slot-scope="scope">
            {{ scope.row | strTrans("year") }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="核验出版物名称" align="center"> </el-table-column>
        <el-table-column prop="organizationName" label="出版单位" align="center"> </el-table-column>
        <el-table-column label="状态" align="center" width="120">
          <template slot-scope="scope">
            {{ scope.row | strTrans("pgstate") }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button @click="goDeep(scope.row)" size="mini">查看</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pageArea" v-if="tabPost.total > 1">
        <el-pagination
          :current-page="tabPost.no"
          @current-change="pageChange"
          layout="prev, pager, next"
          :page-count="tabPost.total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
// import { getPgress } from '@/api/pressRole/pressRole';
import { getLxdzProgress } from "@/api/pressRole/pressRole";

import {
  cancelTabSubmit, // zym.整体撤回提交数据
} from "@/api/pressRole/pressSuccessive";
export default {
  data() {
    return {
      tabDat: [],
      loading: false,
      fileUrl: "",
      tabPost: {
        no: 1,
        size: 15,
        total: 0,
      },
    };
  },
  filters: {
    strTrans: function (dat, code) {
      if (code == "year") {
        return dat.firstYear + "-" + dat.secondYear;
      }
      if (code == "pgstate") {
        let setMap = {
          1: "通过",
          2: "暂缓",
          4: "撤销",
          5: "注销",
        };

        let regist = {
          1: "未登记",
          2: "已登记",
        };

        if (dat.progress == "登记") {
          return regist[dat.record];
        } else if (dat.progress == "国家新闻出版署") {
          if (dat.pubStatus == 1 || dat.pubStatus == 0) {
            return "已上报";
          } else {
            return setMap[dat.pubStatus];
          }
        } else if (dat.progress == "开始") {
          if (dat.isBack == 2) {
            return "未提交（退回）";
          } else {
            return "未提交";
          }
        } else {
          return "已上报";
        }
      }
    },
  },
  methods: {
    tabInit: function () {
      this.loading = true;
      var vm = this;
      //  getPgress(this.tabPost).then(response => {
      getLxdzProgress().then((response) => {
        setTimeout(function () {
          vm.tabDat = response.examineProgressList;
          vm.tabPost.total = response.totalPages;
          vm.loading = false;
        }, 300);
      });
    },
    pageChange: function (inx) {
      this.tabPost.no = inx;
      this.tabInit();
    },
    goDeep: function (dat) {
      this.$router.push({
        path: "successive_read",
        query: {
          listId: dat.publishMaterialId,
          pressId: dat.organizationId,
          bookName: dat.name,
        },
      });
    },
    toCancel: function () {
      let vm = this;
      this.$confirm("确认整体撤回吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const loading = vm.$loading({
            lock: true,
            text: "处理中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });

          cancelTabSubmit().then((response) => {
            loading.close();
            // console.log('response=',JSON.stringify(response));
            let tipCode = response.payload.tipCode;
            let tipMessage = response.payload.message || "操作失败";
            if (tipCode == "fail") {
              this.$message({
                showClose: true,
                message: tipMessage,
                type: "error",
              });
            } else {
              this.$message({
                message: "操作成功！",
                type: "success",
              });
              this.$router.push("successive_press");
            }
          });
        })
        .catch((error) => {});
    },
  },

  created: function () {
    this.tabInit();
    // this.fileUrl = process.env.BASE_API + '/File/File/downloadDrmb?code=002&token=' + encodeURIComponent(this.token);
    this.fileUrl = process.env.URL_FILE + "/drmb/003.xlsx";
  },
};
</script>

<style lang="scss">
.press-5 {
  padding: 9px 12px;

  .tabTtl {
    height: 45px;
    line-height: 45px;
    background: #f8f8f8;
    font-size: 14px;
    padding: 0px 20px;
    color: #666666;
    font-weight: bold;
  }

  .tabArea {
    margin-top: 10px;
  }

  .downBtn {
    float: right;
  }

  .pageArea {
    text-align: center;
    padding: 24px 0px 45px;
  }
}
</style>



// WEBPACK FOOTER //
// examProgressHistory.vue?87e69128